module.exports = {"522722001":"玉屏街道","522722101":"朝阳镇","522722102":"茂兰镇","522722104":"甲良镇","522722105":"佳荣镇","522722107":"小七孔镇","522722211":"瑶山瑶族乡","522722212":"黎明关水族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522722.json
// module id = 2662
// module chunks = 0